import { TOGGLE_SHOW_SHIFTS } from '@/store/action-types';

export default function toggleShowShifts() {
  return {
    type: TOGGLE_SHOW_SHIFTS,
  };
}
